import * as actionTypes from './actionTypes';

export const setPageData = pageData => ({
  type: actionTypes.SET_PAGE_DATA,
  pageData,
});

export const setDocDetails = details => ({
  type: actionTypes.SET_DOC_DETAILS,
  details,
});

export const setSelectedItem = selectedItem => ({
  type: actionTypes.SET_SELECTED_ITEM,
  selectedItem,
});

export const setEditor = editor => ({
  type: actionTypes.SET_EDITOR,
  editor,
});

export const setEditorChanges = editorChanges => ({
  type: actionTypes.SET_EDITOR_CHANGES,
  editorChanges,
});

export const setDocSearchMode = state => ({
  type: actionTypes.SET_DOC_SEARCH_MODE,
  searchMode: state,
});

export const setDocSearchParams = searchParams => ({
  type: actionTypes.SET_DOC_SEARCH_PARAMS,
  searchParams,
});

export const setBookmarks = bookmarks => ({
  type: actionTypes.SET_BOOKMARKS,
  bookmarks,
});

export const setSharedFolderMode = sharedFolderMode => ({
  type: actionTypes.SET_SHARED_FOLDER_MODE,
  sharedFolderMode,
});

export const setDocTreeData = treeData => ({
  type: actionTypes.SET_DOC_TREE_DATA,
  treeData,
});

export const removeTreeArticle = id => ({
  type: actionTypes.REMOVE_TREE_ARTICLE,
  id,
});
